import { useSelector, useDispatch } from 'react-redux';
import Home from './Pages/Home';
import OrganizationLogin from './Pages/OrganizationLogin';
import React, { useEffect, useState } from 'react';
import '../src/index.css';
import 'react-toastify/dist/ReactToastify.css';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { RootState } from './store';
import PassTemplateDashboard from './Pages/PassTemplateDashboard';
import Customers from './Pages/Customers';
import ProgramSidebar from './layouts/ProgramSidebar';
import MainSidebar from './layouts/MainSidebar';
import NotFound from './Pages/NotFound';
import CustomerDetails from './Pages/CustomerDetails';
import SendNotification from './Pages/SendNotification';
import EditPassTemplate from './Pages/EditPassTemplate';
import CustomerSignup from './Pages/CustomerSignup';
import OrganizationSignup from './Pages/OrganizationSignUp';
import ForgotPassword from './Pages/ForgotPassword';
import UpdatePassword from './Pages/UpdatePassword';
import Settings from './Pages/Settings';
import ThankYou from './Pages/ThankYou';
import AxiosInterceptor from './Services/AxiosInterceptor';
import SubUsers from './Pages/SubUsers';
import i18n, { t } from 'i18next';
import PrivacyPolicyPage from './Pages/PrivacyPolicy';
import TermsAndConditionsPage from './Pages/TermsConditions';
import FairUsePolicyPage from './Pages/FairUseProlicy';
import OnBoarding from './Pages/OnBoarding';
import LaunchPage from './Pages/LaunchPage';
import { AppDispatch } from './store';
import { loginWithSession } from './Actions/Organization/AuthActions';


const App: React.FC = () => {
  const isAuthenticated = useSelector((state: RootState) => state.auth.isAuthenticated);
  const dispatch = useDispatch<AppDispatch>();

  // true only when a ?token= param is present — blocks routing until login completes
  const [tokenLoading, setTokenLoading] = useState(() =>
    new URLSearchParams(window.location.search).has('session')
  );

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const session = params.get('session');
    if (session) {
      params.delete('session');
      const newUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
      window.history.replaceState({}, '', newUrl);
      dispatch(loginWithSession(session));
      setTokenLoading(false);
    }
  }, []);

  useEffect(() => {
      // 1. Always set <html lang="…">
      document.documentElement.lang = i18n.language;

      // 2. Use i18next’s built-in dir mapping
      //    (returns "rtl" for ar/he/fa/… or "ltr" otherwise)
      document.documentElement.dir = i18n.dir(i18n.language);
    }, [i18n.language]);

  function NavigateFunctionComponenet() {
    let navigate = useNavigate();
    const [ran,setRan] = useState(false);

    {/* only run setup once */}
    if(!ran){
       AxiosInterceptor(navigate);
       setRan(true);
    }
    return <></>;
  }


  if (tokenLoading) return null;

  return (
    <Router>
      {<NavigateFunctionComponenet />}
      <Routes>
        {/* Route for Organization Login */}
        <Route path="/Login-org" element={<OrganizationLogin />} />
        <Route path="/Signup-org" element={<OrganizationSignup />} />
        <Route path="/Forgot-org" element={<ForgotPassword />} />
        <Route path="/Privacy-Policy" element={<PrivacyPolicyPage />} />
        <Route path="/Fair-Use-Policy" element={<FairUsePolicyPage />} />
        <Route path="/Terms-Conditions" element={<TermsAndConditionsPage />} />
        <Route path="/UpdatePassword/:token" element={<UpdatePassword />} />
          
        <Route
          path='/'
          element={ isAuthenticated? <MainSidebar />:<Navigate to='/login-org' />}
          >
             <Route index element={ <Home />} />
             <Route path='/Settings' element={ <Settings />} />
             <Route path='/ThankYou' element={ <ThankYou />} />
             
          </Route>
        {/* Protected Routes */}
        <Route
          path="/Dashboard"
          element={isAuthenticated ? <ProgramSidebar /> : <Navigate to='/login-org' />}
        >
          <Route
          path="Program/:id"
          element={<PassTemplateDashboard />}
          />
           <Route
          path="Program/:id/launch"
          element={<LaunchPage />}
          />
        <Route
          path="Program/:id/Customers/"
          element={<Customers />}
        />
        <Route
          path="Program/:id/SubUsers/"
          element={<SubUsers />}
        />
        <Route
          path="Program/:id/SendNotification/"
          element={<SendNotification />}
        />
        
         <Route
          path="Program/:id/Customer/:cid"
          element={<CustomerDetails />}
        />

        <Route
          path="Program/:id/Edit"
          element={<EditPassTemplate />}
        />
      </Route>
        <Route path='*' element= {<NotFound />} />
        <Route path="CustomerSignup/:id" element={<CustomerSignup />} />
        <Route path="/onboard" element={<OnBoarding />} />
      </Routes>
    </Router>
  );
}

export default App;
